import { AutoFilterBreezeListComponent } from '@common/classes/auto-filter-list';
import { InvoicePermissions } from '@common/classes/permissions';
import { UploadActionButtonsComponent } from '@common/components/upload-action-buttons.component';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { DialogService } from '@common/services/dialog.service';
import { SharedService } from '@common/services/shared.service';
import { InvoiceService } from '@invoice/services/invoice.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/shared.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "@common/services/dialog.service";
import * as i5 from "@invoice/services/invoice.service";
import * as i6 from "@angular/common";
import * as i7 from "@angular/router";
import * as i8 from "@angular/forms";
import * as i9 from "@fortawesome/angular-fontawesome";
import * as i10 from "@progress/kendo-angular-grid";
import * as i11 from "@progress/kendo-angular-layout";
import * as i12 from "../../../common/components/action-bar/action-bar.component";
import * as i13 from "../../../common/components/app-control/app-control.component";
import * as i14 from "../../../common/components/app-form/app-form.component";
import * as i15 from "../../../common/components/content-header/content-header.component";
import * as i16 from "../../../common/components/app-grid/app-grid.component";
import * as i17 from "../../../common/components/app-control-container/app-control-container.component";
import * as i18 from "../../../common/components/check-icon.component";
import * as i19 from "../../../common/components/accordion-header.component";
import * as i20 from "../../../common/components/popover-list/popover-list.component";
import * as i21 from "@ngx-translate/core";
import * as i22 from "../../../common/pipes/codelist.pipe";
import * as i23 from "../../../common/pipes/pad.pipe";
function InvoiceListComponent_ng_template_6_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r8.numberOfActiveFilters, ")");
  }
}
function InvoiceListComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-accordion-header", 11);
    i0.ɵɵlistener("panelChange", function InvoiceListComponent_ng_template_6_Template_app_accordion_header_panelChange_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.handleFilterHighlighter(true));
    });
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵelement(2, "fa-icon", 12);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, InvoiceListComponent_ng_template_6_span_5_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const panel_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("panel", panel_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(4, 3, "Filters"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.numberOfActiveFilters > 0);
  }
}
function InvoiceListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-form", 14);
    i0.ɵɵlistener("submit", function InvoiceListComponent_ng_template_7_Template_app_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      ctx_r12.search();
      return i0.ɵɵresetView(ctx_r12.onAutoFilterChange());
    });
    i0.ɵɵelementStart(1, "app-control-container", null, 15)(3, "div", 16)(4, "div", 17)(5, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.filter.invoiceNumber = $event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 17)(8, "app-control", 19);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.filter.services = $event);
    });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 17)(11, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.filter.internalInvoiceNumber = $event);
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 17)(14, "app-control", 21);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.filter.typeId = $event);
    });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 17)(17, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_17_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.filter.vesselId = $event);
    });
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 17)(20, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_20_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.filter.iMONumber = $event);
    });
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(22, "div", 16)(23, "div", 17)(24, "app-control", 24);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_24_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.filter.vesselTypeId = $event);
    });
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 17)(27, "app-control", 25);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_27_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.filter.statusIds = $event);
    });
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "div", 17)(30, "app-control", 26);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_30_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.filter.customerId = $event);
    });
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 17)(33, "app-control", 27);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_33_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.filter.vesselVisit = $event);
    });
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 17)(36, "app-control", 28);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_36_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.filter.ataFrom = $event);
    });
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(38, "div", 17)(39, "app-control", 29);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_39_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.filter.ataTo = $event);
    });
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(41, "div", 16)(42, "div", 17)(43, "app-control", 30);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_43_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.filter.berthId = $event);
    });
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 17)(46, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_46_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.filter.purposeOfCallId = $event);
    });
    i0.ɵɵpipe(47, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "div", 17)(49, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_49_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.filter.issuedDateFrom = $event);
    });
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(51, "div", 17)(52, "app-control", 33);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_52_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.filter.issuedDateTo = $event);
    });
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(54, "div", 17)(55, "app-control", 34);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_55_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.filter.automatic = $event);
    });
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(57, "div", 35)(58, "app-control", 36);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_58_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.filter.mineInvoices = $event);
    });
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(60, "div", 35)(61, "app-control", 37);
    i0.ɵɵlistener("ngModelChange", function InvoiceListComponent_ng_template_7_Template_app_control_ngModelChange_61_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.filter.createdToday = $event);
    });
    i0.ɵɵpipe(62, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(63, "div", 38)(64, "div", 39)(65, "div", 40)(66, "button", 41);
    i0.ɵɵlistener("click", function InvoiceListComponent_ng_template_7_Template_button_click_66_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.clearFilter());
    });
    i0.ɵɵelement(67, "fa-icon", 42);
    i0.ɵɵtext(68, " \u00A0 ");
    i0.ɵɵelementStart(69, "span", 43);
    i0.ɵɵtext(70);
    i0.ɵɵpipe(71, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(72, "button", 44);
    i0.ɵɵlistener("click", function InvoiceListComponent_ng_template_7_Template_button_click_72_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r34 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r34.search());
    });
    i0.ɵɵelement(73, "fa-icon", 45);
    i0.ɵɵtext(74, " \u00A0 ");
    i0.ɵɵelementStart(75, "span", 43);
    i0.ɵɵtext(76);
    i0.ɵɵpipe(77, "translate");
    i0.ɵɵelementEnd()()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 68, "Invoice Number"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.invoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(9, 70, "Type of Dues"));
    i0.ɵɵproperty("multi", true)("ngModel", ctx_r1.filter.services)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(12, 72, "ID"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.internalInvoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(15, 74, "Type"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.typeId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(18, 76, "Vessel Name"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.vesselId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(21, 78, "IMO Number"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.iMONumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(25, 80, "Vessel Type"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.vesselTypeId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(28, 82, "Invoice Status"));
    i0.ɵɵproperty("multi", true)("ngModel", ctx_r1.filter.statusIds)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(31, 84, "Payer"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.customerId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(34, 86, "Vessel Visit"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.vesselVisit)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(37, 88, "ATA From"));
    i0.ɵɵproperty("time", true)("ngModel", ctx_r1.filter.ataFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(40, 90, "ATA To"));
    i0.ɵɵproperty("time", true)("ngModel", ctx_r1.filter.ataTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(44, 92, "Berth"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.berthId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(47, 94, "Purpose of Call"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.purposeOfCallId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(50, 96, "Issued Date From"));
    i0.ɵɵproperty("time", true)("ngModel", ctx_r1.filter.issuedDateFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(53, 98, "Issued Date To"));
    i0.ɵɵproperty("time", true)("ngModel", ctx_r1.filter.issuedDateTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(56, 100, "Invoice Creation Type"));
    i0.ɵɵproperty("options", ctx_r1.createdTypeOptions)("ngModel", ctx_r1.filter.automatic)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(59, 102, "My Invoices"));
    i0.ɵɵproperty("isDisabled", ctx_r1.filter.createdById)("ngModel", ctx_r1.filter.mineInvoices)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(62, 104, "Created Today"));
    i0.ɵɵproperty("isDisabled", ctx_r1.filter.createdFrom || ctx_r1.filter.createdTo)("ngModel", ctx_r1.filter.createdToday)("entity", ctx_r1.filter);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(71, 106, "Clear"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(77, 108, "Search"));
  }
}
function InvoiceListComponent_ng_template_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceListComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceListComponent_ng_template_12_ng_container_0_Template, 1, 0, "ng-container", 46);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
function InvoiceListComponent_ng_template_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InvoiceListComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceListComponent_ng_template_15_ng_container_0_Template, 1, 0, "ng-container", 46);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
const _c0 = function (a1) {
  return ["/invoice/view", a1];
};
function InvoiceListComponent_ng_template_16_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 67);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r47 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0, row_r47.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r47.invoiceNumber, " ");
  }
}
const _c1 = function (a0) {
  return {
    text: a0,
    separator: ";",
    width: "150px"
  };
};
function InvoiceListComponent_ng_template_16_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-popover-list", 68);
  }
  if (rf & 2) {
    const dataItem_r48 = ctx.$implicit;
    i0.ɵɵproperty("data", i0.ɵɵpureFunction1(1, _c1, dataItem_r48.services));
  }
}
function InvoiceListComponent_ng_template_16_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 67);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "pad");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r49 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c0, row_r49.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, row_r49.internalInvoiceNumber), " ");
  }
}
function InvoiceListComponent_ng_template_16_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r50 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r50.typeId, "InvoiceType")), " ");
  }
}
function InvoiceListComponent_ng_template_16_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r51 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", row_r51.linkedInvoice == null ? null : row_r51.linkedInvoice.invoiceNumber, " ");
  }
}
function InvoiceListComponent_ng_template_16_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r52 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", row_r52.vesselRevision == null ? null : row_r52.vesselRevision.name, " ");
  }
}
function InvoiceListComponent_ng_template_16_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r53 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r53.statusId, "InvoiceStatus")), " ");
  }
}
const _c2 = function (a1) {
  return ["/vessel-visit/view", a1];
};
function InvoiceListComponent_ng_template_16_ng_template_29_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 67);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r54 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c2, row_r54.vesselVisitId));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r54.voyageNumber, " ");
  }
}
const _c3 = function (a1) {
  return ["/msw-vessel-visit/view", a1];
};
function InvoiceListComponent_ng_template_16_ng_template_29_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 67);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r54 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c3, row_r54.vtsVesselVisitId));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r54.voyageNumber, " ");
  }
}
function InvoiceListComponent_ng_template_16_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceListComponent_ng_template_16_ng_template_29_a_0_Template, 2, 4, "a", 69);
    i0.ɵɵtemplate(1, InvoiceListComponent_ng_template_16_ng_template_29_a_1_Template, 2, 4, "a", 69);
  }
  if (rf & 2) {
    const row_r54 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", row_r54.vesselVisitId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r54.vtsVesselVisitId);
  }
}
function InvoiceListComponent_ng_template_16_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r59 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", row_r59.currencyId, " ");
  }
}
function InvoiceListComponent_ng_template_16_ng_template_47_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 70);
  }
  if (rf & 2) {
    const row_r60 = ctx.$implicit;
    i0.ɵɵproperty("check", row_r60.automatic);
  }
}
const _c4 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
const _c5 = function () {
  return {
    "text-align": "right"
  };
};
function InvoiceListComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 39)(2, "app-grid", 47);
    i0.ɵɵlistener("selectionChange", function InvoiceListComponent_ng_template_16_Template_app_grid_selectionChange_2_listener($event) {
      i0.ɵɵrestoreView(_r62);
      const ctx_r61 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r61.selection = $event);
    })("sortChange", function InvoiceListComponent_ng_template_16_Template_app_grid_sortChange_2_listener($event) {
      i0.ɵɵrestoreView(_r62);
      const ctx_r63 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r63.onSortChange($event));
    });
    i0.ɵɵelement(3, "kendo-grid-checkbox-column", 48);
    i0.ɵɵelementStart(4, "kendo-grid-column", 49);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtemplate(6, InvoiceListComponent_ng_template_16_ng_template_6_Template, 2, 4, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "kendo-grid-column", 51);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵtemplate(9, InvoiceListComponent_ng_template_16_ng_template_9_Template, 1, 3, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "kendo-grid-column", 52);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, InvoiceListComponent_ng_template_16_ng_template_12_Template, 3, 6, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "kendo-grid-column", 53);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵtemplate(15, InvoiceListComponent_ng_template_16_ng_template_15_Template, 3, 6, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "kendo-grid-column", 54);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵtemplate(18, InvoiceListComponent_ng_template_16_ng_template_18_Template, 1, 1, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "kendo-grid-column", 55);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵtemplate(21, InvoiceListComponent_ng_template_16_ng_template_21_Template, 1, 1, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "kendo-grid-column", 56);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵtemplate(24, InvoiceListComponent_ng_template_16_ng_template_24_Template, 3, 6, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "kendo-grid-column", 57);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementStart(27, "kendo-grid-column", 58);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵtemplate(29, InvoiceListComponent_ng_template_16_ng_template_29_Template, 2, 2, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "kendo-grid-column", 59);
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelement(32, "kendo-grid-column", 60);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelement(34, "kendo-grid-column", 61);
    i0.ɵɵpipe(35, "translate");
    i0.ɵɵelement(36, "kendo-grid-column", 62);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementStart(38, "kendo-grid-column", 63);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵtemplate(40, InvoiceListComponent_ng_template_16_ng_template_40_Template, 1, 1, "ng-template", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(41, "kendo-grid-column", 64);
    i0.ɵɵpipe(42, "translate");
    i0.ɵɵelement(43, "kendo-grid-column", 65);
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementStart(45, "kendo-grid-column", 66);
    i0.ɵɵpipe(46, "translate");
    i0.ɵɵtemplate(47, InvoiceListComponent_ng_template_16_ng_template_47_Template, 1, 1, "ng-template", 50);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r6.query)("selectable", i0.ɵɵpureFunction0(65, _c4))("sortable", true)("sort", ctx_r6.gridSort)("selection", ctx_r6.selection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("width", 1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 31, "Invoice Number"));
    i0.ɵɵproperty("width", 110);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(8, 33, "Type of Dues"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(11, 35, "ID"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(14, 37, "Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(17, 39, "Cancelled Invoice"));
    i0.ɵɵproperty("width", 110);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(20, 41, "Vessel Name"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(23, 43, "Status"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(26, 45, "Payer"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(28, 47, "Vessel Visit"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(31, 49, "ATA"));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(66, _c5));
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(33, 51, "Amount"));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(67, _c5));
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(35, 53, "Tax"));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(68, _c5));
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(37, 55, "Total Amount"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(39, 57, "Currency"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(42, 59, "Created By"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(44, 61, "Date Of Creation"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(46, 63, "Auto. inv."));
  }
}
export class InvoiceListComponent extends AutoFilterBreezeListComponent {
  constructor(breezeViewService, sharedService, modalService, dialogService, invoiceService) {
    super(breezeViewService, sharedService, modalService, dialogService);
    this.breezeViewService = breezeViewService;
    this.sharedService = sharedService;
    this.modalService = modalService;
    this.dialogService = dialogService;
    this.invoiceService = invoiceService;
    this.queryName = 'Invoices';
    this.parentRoute = '/invoice/';
    this.excelExport = true;
    this.createPermission = InvoicePermissions.Action.create;
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('Invoices')
    }];
    this.gridSort = [{
      field: 'internalInvoiceNumber',
      dir: 'desc'
    }];
    this.createdTypeOptions = ['Automatic', 'Manual'].map(x => ({
      value: x === 'Automatic',
      label: this.breezeViewService.translateService.instant(x)
    }));
    this.actionBar.push({
      label: this.translateService.instant('Workflow'),
      items: [{
        label: () => this.translateService.instant('Delete'),
        icon: 'trash',
        isDisabled: () => this.selection.length === 0,
        onClick: () => this.delete(),
        permissions: [InvoicePermissions.Action.delete]
      }, {
        label: () => this.translateService.instant('Issue'),
        icon: 'paper-plane',
        isVisible: () => false,
        onClick: () => this.issue(),
        permissions: [InvoicePermissions.Action.issue]
      }, {
        label: () => this.translateService.instant('To Approval'),
        icon: 'pen',
        isDisabled: () => this.selection.length === 0,
        onClick: () => this.toApproval(),
        permissions: [InvoicePermissions.Action.waitingForApproval]
      }, {
        label: () => this.translateService.instant('Approve'),
        icon: 'check',
        isDisabled: () => this.selection.length === 0,
        onClick: () => this.approve(),
        permissions: [InvoicePermissions.Menu.approveInvoice]
      }, {
        label: this.translateService.instant('Reject'),
        icon: 'window-close',
        isDisabled: () => this.selection.length === 0,
        onClick: () => this.reject(),
        permissions: [InvoicePermissions.Action.reject]
      }, {
        label: this.translateService.instant('Send To Archive'),
        icon: 'archive',
        isDisabled: () => this.selection.length === 0,
        onClick: () => this.archive(),
        permissions: [InvoicePermissions.Action.archive]
      }, {
        label: () => this.translateService.instant('Preview'),
        icon: 'eye',
        isDisabled: () => this.selection.length !== 1,
        isVisible: () => false,
        onClick: () => this.breezeViewService.handleCommand('invoice/pdf', {
          id: _.first(this.selection),
          isPdf: true
        }).then(x => {
          UploadActionButtonsComponent.preview('invoice.pdf', x);
        }),
        permissions: [InvoicePermissions.Action.pdf]
      }]
    });
  }
  ngOnInit() {
    super.ngOnInit();
    this.breezeViewService.handleQuery('Printers').then(printers => {
      this.addPrinters(printers);
    });
    this.actionBar.filter(ab => ab.label === 'Export')[0]?.items.push({
      label: this.translateService.instant('Detailed Excel'),
      icon: 'file-excel',
      isDisabled: () => this.isBusy,
      onClick: () => this.queryAndTriggerSaveExcel(true)
    });
  }
  getDefaultFilter(data) {
    return this.breezeViewService.entityManager.createEntity('GetInvoicesQuery', {
      archived: this.activeTab === 1,
      ...data
    });
  }
  delete() {
    super.executeAndHandle(this.queryName, 'invoices/delete', 'Delete');
  }
  issue() {
    const data = {};
    const invoicesCount = _.isEmpty(this.selection) ? this.appGrid.internalData.total : this.selection.length;
    data.query = this.breezeService.convertToDto(this.filter);
    data.query.ids = this.selection;
    return this.invoiceService.invoiceIssueDate({
      title: this.translateService.instant('Invoice Issued Date'),
      message: `${this.translateService.instant(`Are you sure you want to issue invoices`)}(${invoicesCount})?`,
      date: new Date(),
      organizationCode: this.user.organization.code,
      invoiceIds: this.selection
    }).then(result => {
      if (result === false) return;
      this.breezeViewService.handleCommand('invoices/issue', {
        ids: this.selection,
        issueDate: result.date
      }).catch(err => super.handleErrorList(err)).finally(() => this.search());
    });
  }
  toApproval() {
    super.executeAndHandle(this.queryName, 'invoices/approval', 'Send to Approval');
  }
  approve() {
    super.executeAndHandle(this.queryName, 'invoices/approve', 'Approve');
  }
  reject() {
    super.executeAndHandle(this.queryName, 'invoices/reject', 'Reject');
  }
  archive() {
    super.executeAndHandle(this.queryName, 'invoices/archive', 'Archive');
  }
  queryAndTriggerSaveExcel(detailed = false) {
    const invoicesCount = _.isEmpty(this.selection) ? this.appGrid.internalData.total : this.selection.length;
    this.dialogService.confirm(this.translateService.instant(`${detailed ? 'Detailed' : ''} Export`), `${this.translateService.instant(`Are you sure you want Export Invoice${invoicesCount > 1 ? 's' : ''}`)} (${invoicesCount})?`).then(result => {
      if (result !== true) return;
      this.appGrid.detailedExcelExport = detailed;
      super.queryAndTriggerSaveExcel();
    });
  }
  addPrinters(printers) {
    if (_.isEmpty(printers)) {
      return;
    }
    const printButton = {
      label: this.translateService.instant('Print'),
      icon: 'print',
      isSplit: true,
      onClick: () => {
        this.print(_.first(printers).value);
      },
      options: _.map(printers, printer => ({
        label: printer.description,
        icon: 'print',
        onClick: () => {
          this.print(printer.value);
        }
      }))
    };
    const actionButtons = _.find(this.actionBar, x => x.label === this.translateService.instant('Akcije'));
    const afterApproveIndex = _.findIndex(actionButtons?.items, i => (_.isFunction(i.label) ? i.label() : i.label) === this.translateService.instant('Approve')) + 1;
    actionButtons?.items.splice(afterApproveIndex, 0, printButton);
  }
  print(printer) {
    const data = {};
    const invoicesCount = _.isEmpty(this.selection) ? this.appGrid.internalData.total : this.selection.length;
    data.query = this.breezeService.convertToDto(this.filter);
    data.query.ids = this.selection;
    this.dialogService.confirm(this.translateService.instant('Print'), `${this.translateService.instant(`Are you sure you want to print invoices`)}(${invoicesCount})?`).then(result => {
      if (result !== true) {
        return;
      }
      data.getCommand = params => {
        const query = _.clone(data.query);
        query.ids = [params.id];
        return this.breezeViewService.handleCommand('invoice/print', {
          query,
          printer
        }, {
          skipCatch: true
        });
      };
      data.title = this.translateService.instant('Print');
      data.queryName = 'Invoices';
    });
  }
  onSortChange(sort) {
    this.gridSort = sort;
  }
}
InvoiceListComponent.ɵfac = function InvoiceListComponent_Factory(t) {
  return new (t || InvoiceListComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.SharedService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.DialogService), i0.ɵɵdirectiveInject(i5.InvoiceService));
};
InvoiceListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: InvoiceListComponent,
  selectors: [["app-pro-form-list"]],
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 18,
  vars: 13,
  consts: [[3, "items"], [3, "title", "breadcrumb"], [1, "filter-wrapper"], ["activeIds", "ngb-panel-0"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "mt-3", 3, "tabSelect"], ["tabStrip", ""], [3, "title", "selected"], ["kendoTabContent", ""], ["tabContent", ""], [3, "panel", "panelChange"], ["icon", "filter"], [4, "ngIf"], [3, "submit"], ["filterHighlighter", ""], [1, "row"], [1, "col-2"], ["property", "invoiceNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Service", "property", "services", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], ["format", "#", "property", "internalInvoiceNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "InvoiceType", "property", "typeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "iMONumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselType", "property", "vesselTypeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "InvoiceStatus", "property", "statusIds", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Customer", "property", "customerId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "vesselVisit", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "ataFrom", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["property", "ataTo", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "CallPurpose", "property", "purposeOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "issuedDateFrom", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["property", "issuedDateTo", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "property", "automatic", 3, "label", "options", "ngModel", "entity", "ngModelChange"], [1, "col-md-auto"], ["property", "mineInvoices", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "createdToday", 3, "label", "isDisabled", "ngModel", "entity", "ngModelChange"], [1, "row", "mt-3"], [1, "col"], [1, "float-right"], [1, "btn", "btn-sm", "btn-danger", "mr-2", 3, "click"], ["icon", "trash", 1, "ml-1"], [1, "btn-text"], [1, "btn", "btn-sm", "btn-primary", 3, "click"], ["icon", "search", 1, "ml-1"], [4, "ngTemplateOutlet"], ["entityName", "Invoice", "exportFileName", "InvoiceList", 1, "mb-2", 3, "data", "selectable", "sortable", "sort", "selection", "selectionChange", "sortChange"], ["showSelectAll", "true", 3, "width"], ["field", "invoiceNumber", 3, "title", "width"], ["kendoGridCellTemplate", ""], ["field", "services", "width", "160px", 3, "title"], ["field", "internalInvoiceNumber", 3, "title"], ["field", "typeId", 3, "title"], ["field", "linkedInvoice.invoiceNumber", 3, "title", "width"], ["field", "vesselRevision.name", 3, "title"], ["field", "statusId", 3, "title"], ["field", "customer.name", 3, "title"], ["field", "voyageNumber", 3, "title"], ["field", "ata", "format", "g", 3, "title"], ["field", "amount", "format", "n2", 3, "title"], ["field", "taxAmount", "format", "n2", 3, "title"], ["field", "totalAmount", "format", "n2", 3, "title"], ["field", "currencyId", 3, "title"], ["field", "createdBy.fullName", 3, "title"], ["field", "createdDate", "format", "g", 3, "title"], ["field", "automatic", 3, "title"], [1, "text-primary", 3, "routerLink"], [3, "data"], ["class", "text-primary", 3, "routerLink", 4, "ngIf"], [3, "check"]],
  template: function InvoiceListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelement(0, "app-action-bar", 0)(1, "app-content-header", 1);
      i0.ɵɵpipe(2, "translate");
      i0.ɵɵelementStart(3, "div", 2)(4, "ngb-accordion", 3)(5, "ngb-panel");
      i0.ɵɵtemplate(6, InvoiceListComponent_ng_template_6_Template, 6, 5, "ng-template", 4);
      i0.ɵɵtemplate(7, InvoiceListComponent_ng_template_7_Template, 78, 110, "ng-template", 5);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(8, "kendo-tabstrip", 6, 7);
      i0.ɵɵlistener("tabSelect", function InvoiceListComponent_Template_kendo_tabstrip_tabSelect_8_listener($event) {
        return ctx.tabSelected($event);
      });
      i0.ɵɵelementStart(10, "kendo-tabstrip-tab", 8);
      i0.ɵɵpipe(11, "translate");
      i0.ɵɵtemplate(12, InvoiceListComponent_ng_template_12_Template, 1, 1, "ng-template", 9);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(13, "kendo-tabstrip-tab", 8);
      i0.ɵɵpipe(14, "translate");
      i0.ɵɵtemplate(15, InvoiceListComponent_ng_template_15_Template, 1, 1, "ng-template", 9);
      i0.ɵɵelementEnd()();
      i0.ɵɵtemplate(16, InvoiceListComponent_ng_template_16_Template, 48, 69, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      i0.ɵɵproperty("items", ctx.actionBar);
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 7, "Invoices"));
      i0.ɵɵproperty("breadcrumb", ctx.breadcrumb);
      i0.ɵɵadvance(9);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(11, 9, "Invoices"))("selected", ctx.activeTab === 0);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(14, 11, "Archived Invoices"))("selected", ctx.activeTab === 1);
    }
  },
  dependencies: [i6.NgIf, i6.NgTemplateOutlet, i7.RouterLink, i8.NgControlStatus, i8.NgModel, i3.NgbAccordion, i3.NgbPanel, i3.NgbPanelContent, i3.NgbPanelHeader, i9.FaIconComponent, i10.ColumnComponent, i10.CheckboxColumnComponent, i10.CellTemplateDirective, i11.TabStripComponent, i11.TabStripTabComponent, i11.TabContentDirective, i12.ActionBarComponent, i13.AppControlComponent, i14.AppFormComponent, i15.ContentHeaderComponent, i16.AppGridComponent, i17.AppControlContainerComponent, i18.CheckIconComponent, i19.AccordionHeaderComponent, i20.PopoverListComponent, i6.AsyncPipe, i21.TranslatePipe, i22.CodelistPipe, i23.PadPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});